import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "southtrip:token";
const ADMIN_TOKEN_KEY = "southtrip:adminToken";

export const getUserToken = () => localStorage.getItem(TOKEN_KEY);
export const setUserToken = (t) => {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
};
export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const setAdminToken = (t) => {
    if (t) localStorage.setItem(ADMIN_TOKEN_KEY, t);
    else localStorage.removeItem(ADMIN_TOKEN_KEY);
};

const api = axios.create({ baseURL: API_BASE, timeout: 20000 });

api.interceptors.request.use((config) => {
    // Admin endpoints get the admin token, otherwise user token
    const isAdmin = (config.url || "").startsWith("/admin");
    const token = isAdmin ? getAdminToken() : getUserToken();
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const api_get = (url, params) => api.get(url, { params }).then((r) => r.data);
export const api_post = (url, body) => api.post(url, body).then((r) => r.data);
export const api_put = (url, body) => api.put(url, body).then((r) => r.data);
export const api_delete = (url) => api.delete(url).then((r) => r.data);

export const apiError = (err, fallback = "Something went wrong.") => {
    const msg = err?.response?.data?.detail || err?.message || fallback;
    return typeof msg === "string" ? msg : fallback;
};

export default api;
